import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { Bell, Mic, Video, Sparkles, Rocket } from 'lucide-react';
interface Props {
  onRestart: () => void;
}
const items = [{
  icon: Mic,
  label: 'Who gets interviewed'
}, {
  icon: Video,
  label: 'What stories get captured'
}, {
  icon: Sparkles,
  label: 'What moments we bring back'
}, {
  icon: Rocket,
  label: 'What momentum looks like next'
}];
export const Screen8Close = ({
  onRestart
}: Props) => {
  return <div className="relative w-full h-full bg-slate-950 overflow-hidden flex flex-col" data-id="element-450">
      {/* Cinematic background */}
      <motion.div initial={{
      scale: 1.1,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      duration: 8,
      ease: 'easeOut'
    }} className="absolute inset-0" data-id="element-451">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1559223607-a43c990c692c?q=80&w=1200&auto=format&fit=crop')] bg-cover bg-center opacity-30 mix-blend-luminosity" data-id="element-452" />
      </motion.div>

      <div className="absolute inset-0 bg-gradient-to-b from-slate-950/80 via-slate-950/90 to-slate-950" data-id="element-453" />
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-red-700/30 rounded-full blur-[120px]" data-id="element-454" />

      <div className="relative z-10 flex-1 flex flex-col p-8 pt-16" data-id="element-455">
        <motion.span initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} className="text-[10px] tracking-[0.3em] uppercase text-red-500 font-semibold mb-6" data-id="element-456">
          08 — Momentum
        </motion.span>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-3xl font-bold text-white leading-tight mb-3" data-id="element-457">
          You’re helping shape what happens at{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-400 to-red-600" data-id="element-458">
            ERA.
          </span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2,
        duration: 0.8
      }} className="text-base text-slate-400 font-light mb-8" data-id="element-459">
          Your input helps decide:
        </motion.p>

        <div className="space-y-3 mb-8" data-id="element-460">
          {items.map((item, i) => {
          const Icon = item.icon;
          return <motion.div key={item.label} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.4 + i * 0.1,
            duration: 0.5
          }} className="flex items-center space-x-3 bg-slate-900/40 backdrop-blur-sm border border-slate-800 rounded-2xl px-4 py-3" data-id="element-461">
                <div className="w-9 h-9 rounded-xl bg-red-600/20 border border-red-500/30 flex items-center justify-center" data-id="element-462">
                  <Icon className="w-4 h-4 text-red-400" strokeWidth={1.5} data-id="element-463" />
                </div>
                <span className="text-sm text-white font-medium" data-id="element-464">
                  {item.label}
                </span>
              </motion.div>;
        })}
        </div>

        <div className="mt-auto" data-id="element-465">
          <motion.button initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 1,
          duration: 0.6
        }} className="w-full bg-red-600 hover:bg-red-500 text-white font-semibold py-4 rounded-2xl flex items-center justify-center space-x-2 shadow-[0_10px_40px_rgba(220,38,38,0.4)] active:scale-[0.98] transition-all mb-3" data-id="element-466">
            <Bell className="w-4 h-4" data-id="element-467" />
            <span data-id="element-468">Follow ERA Pulse</span>
          </motion.button>

          <motion.button initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 1.2
        }} onClick={onRestart} className="w-full text-slate-400 hover:text-white text-sm py-2 transition-colors" data-id="element-469">
            Restart experience
          </motion.button>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 1.4,
          duration: 0.8
        }} className="mt-6 pt-6 border-t border-slate-800 flex items-center justify-center space-x-3" data-id="element-470">
            {['Attract', 'Retain', 'Mobilize'].map((word, i) => <Fragment key={word} data-id="element-471">
                <span className="text-xs font-semibold tracking-[0.2em] uppercase text-white" data-id="element-472">
                  {word}.
                </span>
                {i < 2 && <span className="w-1 h-1 rounded-full bg-red-500" data-id="element-473" />}
              </Fragment>)}
          </motion.div>
        </div>
      </div>
    </div>;
};